import {LitElement, html} from 'lit';
import {jhaIconStyles} from '../styles/jha-icon-styles.js';
/**
 * @element jha-icon-search
 * @customElement jha-icon-search
 */
export default class JhaIconSearch extends LitElement {
  static get styles() {
    return [jhaIconStyles];
  }

  render() {
    // icon svg's contain ? in the tag which is invalid according to the linter
    // eslint-disable-next-line lit/no-invalid-html
    return html`
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">   <path fill-rule="evenodd" d="M4.625 10.376a5.75 5.75 0 1 1 11.5 0 5.75 5.75 0 0 1-11.5 0Zm5.75-7.25a7.25 7.25 0 1 0 4.569 12.88l4.65 4.65a.75.75 0 1 0 1.061-1.06l-4.65-4.652a7.25 7.25 0 0 0-5.63-11.819Z"/> </svg> 
    `;
  }
}

customElements.define('jha-icon-search', JhaIconSearch);
